export default __webpack_public_path__ + "media/images/icons/phone-alt-solid-7df015ac50ab94f543b462dbed99f25e.svg";